export default "__VITE_ASSET__pGt8w2Ax__"